// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "container-3XmRR";
var _4 = "row-G5Gci";
var _5 = "col-3mJe_";
var _6 = "request-2RlDl";
var _7 = "date-3MCNR";
var _8 = "status-x2vQG";
export { _1 as "__esModule", _2 as "mobile", _3 as "container", _4 as "row", _5 as "col", _6 as "request", _7 as "date", _8 as "status" }
export default { "__esModule": _1, "mobile": _2, "container": _3, "row": _4, "col": _5, "request": _6, "date": _7, "status": _8 }
